import {
  Link,
  Typography,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
} from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Profile } from '@par/shared/types/player';
import { utcToLocalDateTime } from '../room/utils';

type PropTypes = {
  handleResetPlayer: (profileId: string) => void;
  users?: Profile[];
};

export const AllPlayers = ({ handleResetPlayer, users }: PropTypes) => {
  const navigate = useNavigate();

  const handleUsernameClick = (row: any) => {
    navigate(`/profile/overview/${row.id}`);
  };

  return (
    <>
      <Typography
        id="modal-modal-title"
        variant="h5"
        component="h2"
        mb={2}
        textAlign="center"
      >
        All Players
      </Typography>
      <TableContainer component={Paper} sx={{ maxHeight: 600 }}>
        <Table stickyHeader size="small" aria-label="sticky table">
          <TableHead>
            <TableRow>
              <TableCell>Username</TableCell>
              <TableCell>Email</TableCell>
              <TableCell>Profile ID</TableCell>
              <TableCell>Last Login</TableCell>
              <TableCell>Reset</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {users?.map((row) => (
              <TableRow key={row.id}>
                <TableCell>
                  <Link
                    sx={{ cursor: 'pointer' }}
                    onClick={() => handleUsernameClick(row)}
                  >
                    {row.username}
                  </Link>
                </TableCell>
                <TableCell>{row.email}</TableCell>
                <TableCell>{row.id}</TableCell>
                <TableCell>{utcToLocalDateTime(row.lastLogin)}</TableCell>
                <TableCell>
                  <Button onClick={() => handleResetPlayer(row.id)}>
                    Reset
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};
